module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_11-e9dfeddcb4c0485d8c3d33ac51267105.png";